<template>
    <!-- 信息汇总 -->
    <div class="content insuranceCompanyInfoCollect">
      <Form ref="formInline" :model="formData" class="page-form less" :label-width="100">
        <FormItem label="内容" prop="content" class="full">
          <div v-html="formData.content"></div>
        </FormItem>
        <FormItem class="full" label="文件" prop="fileUrl">
          <Row v-for="(item, index) in formData.fileUrl" :key="index">
            <Row
              ><Col
                ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
              ></Row>
          </Row>
        </FormItem>
      </Form>
    </div>
  </template>
  <script>
  import editor from '@/components/commons/editor';
  export default {
    components: { editor },
    data: () => ({
      formData: {
        id: '',
        companyId: '',
        content: '',
        intro: []
      }
    }),
    created() {
      this.getDetail()
    },
    methods: {
      //基本信息
      getDetail() {
        this.$http({
          url: `/buz/articleBase/read/detail`,
          type: 'GET',
          data: {
            id:  this.$route.query.id
          }
        }).then(res => {
          res.data.fileUrl = JSON.parse(res.data.fileUrl || '[]');
          this.formData = res.data;
        });
      },
  
      toUrl(url) {
        window.open(url);
      }
    }
  };
  </script>
  <style lang='scss' scoped>
  
  </style>